/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const GasPump = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.49999 2.5H14.4963V10H13.4999H4.49998H3.49999V2.5ZM2.99999 11.5H2V10V2.5V1H3.49999H14.4963H15.9963V2.5V10V11.5H14.9999V13.2497L16.9959 13.2497C17.9623 13.2497 18.7458 14.0332 18.7458 14.9996V18.3724C18.7458 18.8569 19.1385 19.2496 19.623 19.2495C20.1074 19.2495 20.5 18.8568 20.5 18.3724V11.5H20.4947H18.9959H17.4959V10V6.9151L20.4951 4.5H20.4986V3.91724L18.7055 2.03448L19.7917 1L21.9986 3.31724V7.51724H21.9947V10V10.9994H22V18.3724C22 19.6852 20.9359 20.7494 19.6231 20.7495C18.3102 20.7497 17.2458 19.6854 17.2458 18.3724V14.9996C17.2458 14.8616 17.1339 14.7497 16.9959 14.7497L14.9999 14.7497L15 20H13.4999V11.5H4.49998V21.5H13.4999H14.9999V23H13.4999H4.49998H2.99999V21.5V11.5ZM18.9959 10V7.6331L20.4947 6.42617V10H18.9959Z"
                        fill={color}
                    />
                </svg>
        );
    };
